import { useMemo } from 'react';
import { type Components } from '@tecnobit-srl/components-store';
import { type Content } from '@tecnobit-srl/types';
import { useCoreContentTypes } from '@tecnobit-srl/content-types-core';
import { useReviewsContentTypes } from '@tecnobit-srl/reviews-content-types-core';
import { useCoursesContentTypes } from '@tecnobit-srl/courses-content-types-core';
import { useConsultanciesContentTypes } from '@tecnobit-srl/consultancies-content-types-core';
import { useVariantContentTypes } from '@variant';

export const useContentTypes = (): Components<Content> => {
  const core = useCoreContentTypes();
  const reviews = useReviewsContentTypes();
  const courses = useCoursesContentTypes();
  const consultancies = useConsultanciesContentTypes();
  const variant = useVariantContentTypes();
  return useMemo(
    () => ({
      ...core,
      ...reviews,
      ...courses,
      ...consultancies,
      ...variant,
    }),
    [core, reviews, courses, consultancies, variant]
  );
};
